import React, { useState, useEffect, forwardRef, useImperativeHandle } from "react";
import {
  Modal,
  Button,
  Space,
  Descriptions,
 Form
} from "antd";
import { HomeOutlined } from "@ant-design/icons";
import moment from "moment";
import http from "@/utils/http";
import api from "@/utils/api";
import commonFn from "@/utils/commonFn";
import { CustomTable , FileDetail} from "@/hocComponents";
 import ViewPayment from "@/views/AccountPayable/ApprovalHistory/ViewPayment";
const PaymentModal = forwardRef(({ }, ref) => {
  const [modalName, setModalName] = useState('Vendor Payments');
  const [modalFlag, setModalFlag] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);
  const [tableList, setTableList] = useState([]);
  const [tableLoading, setTableLoading] = useState(false);
  const [tableHead, setTableHead] = useState({});
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 25,
    total: 0,
  });
    const [viewPaymentRecord, setViewPaymentRecord] = useState(null);
    const [viewPaymentOpen, setViewPaymentOpen] = useState(false);
    const [checkFileList, setCheckFileList] = useState([]);
    const [checkModalFlag, setCheckModalFlag] = useState(false);
    const [form] = Form.useForm();
  // 存储当前选中的 record
  const [currentRecord, setCurrentRecord] = useState(null);

  // 定义初始列配置
  const initColumns = [
    {
      title: "Trust",
      dataIndex: "trust",
      titleType: "",
    },
    {
      title: 'Prop',
      dataIndex: "prop",
      titleType: 'Input',
      onChange: e => tableFilterFn(e, 'prop')
    },
    {
      title: 'Address',
      dataIndex: "address",
      titleType: 'Input',
      onChange: e => tableFilterFn(e, 'address')
    },
    {
      title: "City",
      dataIndex: "city",
      titleType: "",
    },
    {
      title: "Vendor Name",
      dataIndex: "vendorName",
      titleType: "",
      width: 200,
      onChange: (e) => tableFilterFn(e, "vendorName"),
    },
    {
      title: 'Gl-Title',
      dataIndex: "glAcct",
      titleType: 'Input',
      onChange: e => tableFilterFn(e, 'glAcct'),
    },
    {
      title: 'Check Date',
      dataIndex: "checkDate",
      titleType: 'DatePicker',
      isSorter: false,
      format: 'MM/DD/YYYY',
      onChange: (e) => tableFilterFn(e, 'checkDate', 'DatePickerFormat'),
    },
    {
      title: "Check #",
      dataIndex: "checkNumber",
      titleType: "Input",
      width: 110,
      onChange: (e) => tableFilterFn(e, 'checkNumber'),
      render: (text, record) => {
        if (text == null || text === "") return "";
        if(!record?.checkCopyFileStatus) return text
        return (
          <span
            onClick={() => (setCheckFileList([record?.checkCopyFile]), setCheckModalFlag(true))}
            style={{
              color: "#1890ff",
              cursor: "pointer",
            }}
          >
            {text}
          </span>
        );
      },
    },
    {
      title: "Amount",
      dataIndex: "amount",
      titleType: "Input",
      isSorter: true,
      isAmountFlag: true,
      sortterMultiple: 3,
      onChange: (e) => tableFilterFn(e, "amount"),
     render: (text, record) => {
        if (text == null || text === "") return "-";
        const colorMatch = {
          0: '#000',
          1: '#dd4b39',
          2: 'green',
          3: '#f39c12',
        }
        return (
          <span
            onClick={() => {
              if(!record?.paymentColorStatus) return
              setViewPaymentRecord({
                ...record,
                paymentId: record.vendorPaymentId,
                type: 'approval'
              })
              setViewPaymentOpen(true)
            }}
            style={{
              color: colorMatch[record?.paymentColorStatus || 0],
              cursor: record?.paymentColorStatus ? "pointer" : "",
            }}
          >
            {commonFn.amountToDollarFn(text)}
              <br />
            {record?.paymentStatusRemark}
          </span>
        );
      },
    },
    {
      title: 'Bank #',
      dataIndex: "bankAcctNumber",
      titleType: 'Input',
      onChange: e => tableFilterFn(e, 'bankAcctNumber'),
    },
    {
      title: 'Customer #',
      dataIndex: "customerNumber",
      titleType: 'Input',
      onChange: e => tableFilterFn(e, 'customerNumber'),
    },
    {
      title: 'Invoice #',
      dataIndex: "invoiceNumber",
      titleType: 'Input',
      onChange: e => tableFilterFn(e, 'invoiceNumber'),
    },
    {
      title: 'Check Memo',
      dataIndex: "checkMemo",
      titleType: 'Input',
      width: 180,
      onChange: e => tableFilterFn(e, 'checkMemo'),
    },
    {
      title: "Batch",
      dataIndex: "batchNumber",
      titleType: 'Input',
      onChange: e => tableFilterFn(e, 'batchNumber'),
    },
    {
      title: 'Updated Date',
      dataIndex: "updatedDate",
      titleType: '',
      onChange: (e) => tableFilterFn(e, 'updatedDate', 'DatePickerFormat'),
    },
    {
      title: 'Print By',
      dataIndex: "printBy",
      titleType: '',
    },
  ];

  const [columns, setColumns] = useState(initColumns);

  // 表格筛选函数
  const tableFilterFn = (event, key, type = 'Input') => {
    commonFn.tableFilterFn({ event, key, type, setTableHead, getTableListFn });
  };

  // 获取列表数据
  const getTableListFn = async (current, pageSize, tableHeadParams = {}) => {
    setTableLoading(true);
    const params = {
      page: current || pagination.current,
      count: pageSize || pagination.pageSize,
      ...tableHeadParams,
      vendorId: currentRecord?.vendorId,
    };
    try {
      const response = await http.post(api.getVendorByPayment, params);
      if (!response) {
        setTableLoading(false);
        return;
      }
      if (response && response?.code !== "1") {
        commonFn.modalFailedFn(response);
        setTableLoading(false);
        return;
      }
      const list = (response.data.list || []).map((item, index) => ({ 
        ...item, 
      }));
      setTableList(list);
      setPagination((prev) => ({
        ...prev,
        total: response.data.total || 0,
        current: params.page,
        pageSize: params.count,
      }));
    } catch (error) {
      console.error('获取列表失败:', error);
    } finally {
      setTableLoading(false);
    }
  };

  // 表格变化处理
  const handleTableChange = (pagination, filters, sorter) => {
    getTableListFn(pagination.current, pagination.pageSize, tableHead);
  };

  // 重置列和数据
  const initColunmsFn = () => {
    setPagination({
      current: 1,
      pageSize: 25,
      total: 0,
    });
    setTableList([]);
    setTableHead({});
    setColumns(initColumns);
  };

  // Modal 打开后的回调
  const afterOpenChangeFn = (open) => {
    if (open) {
      setRefreshKey(prev => prev + 1);
    }
  };
  useImperativeHandle(ref, () => ({
    openModal: (record) => {
      if (record && record.name) {
        setModalName(`${record.name} - Payment`);
        setCurrentRecord(record);
      } else {
        setModalName('Vendor Payments');
        setCurrentRecord(null);
      }
      setModalFlag(true);
    },
    closeModal: () => {
      setModalFlag(false);
    },
  }));

  // 初始化数据
  useEffect(() => {
    initColunmsFn();
    getTableListFn(1, 25);
  }, [refreshKey]);

  return (
    <Modal
      title={
        <div style={{ fontSize: "24px", fontWeight: "bold", color: "#3c8dbc" }}>
          <HomeOutlined style={{ marginRight: "8px" }} />
          {modalName}
          <div
            style={{ borderTop: "3px solid #3c8dbc", marginTop: "8px" }}
          ></div>
        </div>
      }
      centered
      open={modalFlag}
      onCancel={() => setModalFlag(false)}
      footer={null}
      maskClosable={false}
      afterOpenChange={afterOpenChangeFn}
      width="80%"
    >
      <CustomTable
        refreshKey={refreshKey}
        tableLoading={tableLoading}
        rowSelection={false}
        rowKey="id"
        columns={columns}
        tableList={tableList}
        pagination={pagination}
        handleTableChange={handleTableChange}
      />
      <ViewPayment
        addopen={viewPaymentOpen}
        form={form}
        handleModalCancelFn={() => setViewPaymentOpen(false)}
        record={viewPaymentRecord}
      />
      <Modal
        title="VIEW CHECK #"
        width="50%"
        maskClosable={false}
        open={checkModalFlag}
        onCancel={() => (setCheckModalFlag(false), setCheckFileList([]))}
        footer={false}
      >
        <FileDetail
          urlKey="url"
          nameKey="fileName"
          fileList={checkFileList || []}
          customConfig={{
            pdfHeight: "74vh",
            pdfUrlArg: '#zoom=56'
          }}
        />
      </Modal>

    </Modal>
  );
});

export default PaymentModal;